import { encrypt, decrypt } from './crypto'
import { globalConfig } from './types'
export { storagekeys } from './storegakey'

const config: globalConfig = {
  type: 'localStorage',
  prefix: 'yt_',
  expire: 24 * 60, // 过期时间，默认为一天，单位为分钟
  isEncrypt: false // 支持加密、解密数据处理
}

const set = (
  key: string,
  value: any,
  expire?: number // 分钟为单位
): boolean => {
  //设定值
  if (value === '' || value === null || value === undefined) {
    //空值重置
    value = null
  }
  if (expire !== undefined && expire < 0) {
    //过期时间值合理性判断
    throw new Error('Expire must be a number')
  }
  const now = Date.now()
  const data: any = {
    value, //存储值
    time: now //存储日期
  }
  if (expire) {
    data['expire'] = now + 1000 * 60 * expire //过期时间
  }

  try {
    window[config.type].setItem(
      autoAddPreFix(key),
      config.isEncrypt ? encrypt(JSON.stringify(data)) : JSON.stringify(data)
    )
    return true
  } catch (err) {
    return false
  }
  //是否需要加密，判断装载加密数据或原数据
}

const get = <T = any>(key: string): T | null => {
  //获取指定值
  if (config.prefix) {
    key = autoAddPreFix(key)
  }
  if (!window[config.type].getItem(key)) {
    //不存在判断
    return null
  }

  try {
    const storageVal = config.isEncrypt
      ? JSON.parse(decrypt(window[config.type].getItem(key) as string))
      : JSON.parse(window[config.type].getItem(key) as string)
    const now = Date.now()
    if (storageVal?.expire && now >= storageVal.expire) {
      //过期销毁
      remove(key)
      return null
      //不过期回值
    } else {
      return storageVal.value
    }
  } catch (err) {
    console.error(err)
    return null
  }
}

const getAllStorage = () => {
  //获取所有值

  const storageList: any = {}
  const keys = Object.keys(window[config.type])
  keys.forEach(key => {
    const value = get(autoRemovePreFix(key))
    if (value !== null) {
      //如果值没有过期，加入到列表中
      storageList[autoRemovePreFix(key)] = value
    }
  })
  return storageList
}

const getStorageLength = () => {
  //获取值列表长度
  return window[config.type].length
}

const remove = (key: string) => {
  //删除值
  if (config.prefix) {
    key = autoAddPreFix(key)
  }
  window[config.type].removeItem(key)
}

const clearStorage = () => {
  window[config.type].clear()
}
const autoAddPreFix = (key: string) => {
  //添加前缀，保持唯一性
  const prefix = config.prefix || ''
  return `${prefix}_${key}`
}
const autoRemovePreFix = (key: string) => {
  //删除前缀，进行增删改查
  const lineIndex = config.prefix.length + 1
  return key.substr(lineIndex)
}

export default {
  set,
  get,
  remove,
  getAllStorage,
  getStorageLength,
  clearStorage
}
